import React from "react";

const PORTRAIT = `${process.env.PUBLIC_URL}/images/residential.jpg`; // Pinette kebony deck — warm residential scene

export const StudioStatement = () => {
  return (
    <section
      id="studio"
      data-testid="studio-statement"
      className="py-28 md:py-40"
    >
      <div className="container-editorial grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-start">
        <div className="md:col-span-5 reveal">
          <div className="relative overflow-hidden" style={{ aspectRatio: "4 / 5" }}>
            <img
              src={PORTRAIT}
              alt="An interior detail from a studio Brehaut residence"
              className="w-full h-full object-cover"
              loading="lazy"
              decoding="async"
            />
          </div>
          <p
            className="mt-5 text-[10px] md:text-[11px] uppercase font-body"
            style={{
              color: "hsl(var(--muted-foreground))",
              letterSpacing: "0.28em",
            }}
          >
            Pinette Residence — Kebony Deck
          </p>
        </div>

        <div className="md:col-span-7 md:col-start-7 md:pl-4 lg:pl-14 reveal">
          <p
            className="text-[11px] uppercase font-body mb-8"
            style={{ color: "#3a7d7b", letterSpacing: "0.36em" }}
          >
            — The Studio
          </p>
          <blockquote
            className="font-display italic leading-[1.04] tracking-[-0.018em]"
            style={{ fontSize: "clamp(2.25rem, 5.6vw, 5.25rem)", fontWeight: 400 }}
          >
            We don’t simply design houses. We envision&nbsp;the whole&nbsp;home.
          </blockquote>

          <div
            className="mt-10 md:mt-14 max-w-xl font-body text-base md:text-[17px] leading-[1.8] space-y-5"
            style={{ color: "hsl(var(--foreground) / 0.82)" }}
          >
            <p>
              We are a Prince Edward Island-based firm providing comprehensive architectural
              services for residential, commercial, and institutional building projects.
            </p>
            <p>
              Located in Guernsey Cove overlooking the Northumberland Strait, we take our
              inspiration from the surrounding rural landscapes and seascapes to produce designs
              with an unmistakable East Coast flavour.
            </p>
            <p>
              With more than thirty years of professional experience, the studio Brehaut team
              establishes close working relationships with our clients to create beautiful,
              purposeful, and sustainable designs that meet exacting tastes and needs.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StudioStatement;
